/**
 * Shows and hides indicators for a single subcategory
 * @param {String} viewType
 */
function toggleIndicators(viewType) {
  this.subcategory.showCurrentIndicators = !this.subcategory.showCurrentIndicators;
}
/**
 * shows or hides all indicators.
 *
 * @param {string} viewType used to indicate which screen is being opened if we
 * want the indicators to reset to close on new screens
 * @param {boolian} openBool
 */
function openCloseAll(viewType, openBool) {
  let i;
  let j;
  for (i = 0; i < this.categories.length; i += 1) {
    for (j = 0; j < this.categories[i].subcategories.length; j += 1) {
      this.categories[i].subcategories[j][viewType] = openBool;
    }
  }
}
function setAria() {
  this.$el.setAttribute('aria-hidden', !this.showIndicators);
}

export { toggleIndicators, openCloseAll, setAria };



// WEBPACK FOOTER //
// ./src/helpers/openCloseHelpers.js